import XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";

export const exportStudentExcel = ({
    reportData,
    columns,
    instituteName,
    selectedSectionName
}) => {

    const wb = XLSX.utils.book_new();

    const wsData = [];

    //-----------------------------------------
    // Heading
    //-----------------------------------------

    wsData.push([instituteName]);
    wsData.push([]);
    wsData.push([`Student Listing`]);
    wsData.push([`Section : ${selectedSectionName}`]);
    wsData.push([]);

    //-----------------------------------------
    // Column Headers
    //-----------------------------------------

    wsData.push(columns.map(col => col.header));

    //-----------------------------------------
    // Data
    //-----------------------------------------

    reportData.forEach(row => {

        wsData.push(
            columns.map(col => row[col.field] ?? "")
        );

    });

    //-----------------------------------------
    // Worksheet
    //-----------------------------------------

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    //-----------------------------------------
    // Merge Heading
    //-----------------------------------------

    ws["!merges"] = [

        {
            s: { r: 0, c: 0 },
            e: { r: 0, c: columns.length - 1 }
        },

        {
            s: { r: 2, c: 0 },
            e: { r: 2, c: columns.length - 1 }
        },

        {
            s: { r: 3, c: 0 },
            e: { r: 3, c: columns.length - 1 }
        }

    ];

    //-----------------------------------------
    // Styling
    //-----------------------------------------

    const range = XLSX.utils.decode_range(ws["!ref"]);

    for (let R = range.s.r; R <= range.e.r; ++R) {

        for (let C = range.s.c; C <= range.e.c; ++C) {

            const ref = XLSX.utils.encode_cell({ r: R, c: C });

            if (!ws[ref]) continue;

            ws[ref].s = {

                border: {
                    top: { style: "thin" },
                    bottom: { style: "thin" },
                    left: { style: "thin" },
                    right: { style: "thin" }
                },

                alignment: {
                    vertical: "center",
                    horizontal: "left",
                    wrapText: true
                },

                font: {
                    name: "Calibri",
                    sz: 11
                }

            };

            //---------------------------------
            // Heading
            //---------------------------------

            if (R === 0) {

                ws[ref].s = {

                    ...ws[ref].s,

                    font: {
                        bold: true,
                        sz: 16
                    },

                    alignment: {
                        horizontal: "center"
                    }

                };

            }

            //---------------------------------
            // Report Title
            //---------------------------------

            if (R === 2 || R === 3) {

                ws[ref].s = {

                    ...ws[ref].s,

                    font: {
                        bold: true,
                        sz: 12
                    }

                };

            }

            //---------------------------------
            // Header Row
            //---------------------------------

            if (R === 5) {

                ws[ref].s = {

                    ...ws[ref].s,

                    font: {
                        bold: true
                    },

                    fill: {
                        fgColor: {
                            rgb: "D9EAF7"
                        }
                    },

                    alignment: {
                        horizontal: "center",
                        vertical: "center",
                        wrapText: true
                    }

                };

            }

        }

    }

    //-----------------------------------------
    // Auto Column Widths
    //-----------------------------------------

    ws["!cols"] = columns.map(col => ({

        wch: Math.max(
            col.header.length + 4,
            15
        )

    }));

    //-----------------------------------------
    // Workbook
    //-----------------------------------------

    XLSX.utils.book_append_sheet(
        wb,
        ws,
        "Student Master"
    );

    const wbout = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array"
    });

    saveAs(
        new Blob(
            [wbout],
            { type: "application/octet-stream" }
        ),
        "Student_Master_Report.xlsx"
    );

};
